import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useProjects } from "../lib/ProjectContext";
import { HelpMenu } from "./HelpMenu";
import { NotificationsBell } from "./NotificationsBell";

const ROUTE_TITLE: Record<string, string> = {
  "/": "Project overview",
  "/ask": "CEI Nexus Assist",
  "/sources": "Knowledge library",
  "/contract-docs": "Project documents",
  "/escalations": "Expert questions",
  "/network": "CEI Nexus Connect",
  "/messages": "Messages",
  "/upload": "Upload intelligence",
  "/review": "Review queue",
  "/projects/new": "New project",
  "/settings": "Settings",
  "/admin/users": "Users",
  "/admin/answer-quality": "Answer quality",
};

export function Topbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { projects, selectedProjectId } = useProjects();
  const project = projects.find((p) => p.id === selectedProjectId);
  const title = ROUTE_TITLE[location.pathname] ?? "CEI Nexus";
  const subParts = [project?.name, project?.contractNumber ? `Contract #${project.contractNumber}` : null].filter(Boolean);

  useEffect(() => {
    function onKeyDown(event: KeyboardEvent) {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
        event.preventDefault();
        navigate("/ask");
      }
    }
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [navigate]);

  return (
    <div className="topbar">
      <div className="topbar-meta">
        <span className="topbar-title">{title}</span>
        {subParts.length > 0 && <span className="topbar-sub mono">{subParts.join(" · ")}</span>}
      </div>
      <div className="topbar-actions">
        <button className="topbar-command" type="button" onClick={() => navigate("/ask")} aria-label="Search this project or ask CEI Nexus">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <circle cx="7" cy="7" r="4.25" stroke="currentColor" strokeWidth="1.3" />
            <path d="m10.3 10.3 3.1 3.1" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
          </svg>
          <span>Search project or ask Nexus</span>
          <kbd>⌘K</kbd>
        </button>
        <NotificationsBell />
        <HelpMenu />
      </div>
    </div>
  );
}
